import { Component, Inject, OnInit } from "@angular/core";
import { ProductOptions } from "app/_models/optionsList/options";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OptionslistService } from "app/_services/optionslist.service";
import { CrudCategoryService } from "app/_services/MasterCrudOps/crudcategory.service";
declare const swal: any;

@Component({
  selector: "app-add-category",
  templateUrl: "./add-category.component.html",
  styleUrls: ["./add-category.component.css"],
})
export class AddCategoryComponent implements OnInit {
  addCategoryForm: UntypedFormGroup;
  productOptions: ProductOptions[] = [];
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly toastr: ToastrService,
    private readonly dialogRef: MatDialogRef<AddCategoryComponent>,
    private readonly optionslistService: OptionslistService,
    private readonly crudCategoryService: CrudCategoryService,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.initilizeForm();
  }

  ngOnInit(): void {
    this.initilizeForm();
    this.optionslistService.getProductsOptions().subscribe((productOptions) => {
      this.productOptions = productOptions;
    });
  }

  initilizeForm() {
    this.addCategoryForm = this.formBuilder.group({
      categoryName: [null, [Validators.required, Validators.maxLength(50)]],
      description: [null, [Validators.required, Validators.maxLength(100)]],
      productId: [null, [Validators.required]],
    });
  }

  saveCategory() {
    let errorMessage = "";
    const categoryName = (this.addCategoryForm.value.categoryName ?? "").trim();
    const description = (this.addCategoryForm.value.description ?? "").trim();
    const productId = this.addCategoryForm.value.productId;

    if (categoryName.length > 50) {
      errorMessage = "category name cannot be more than 50 characters.";
    }
    if (description.length > 100) {
      errorMessage += "\nDescription cannot be more than 100 characters.";
    }
    if (productId == null || productId < 1) {
      errorMessage += "\nlease select a product.";
    }

    if (errorMessage.length > 0) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    } else {
      swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "YES, Add IT!",
      }).then((result) => {
        if (result === true) {
          this.addCategory();
        } else {
          this.toastr.info("result not saved");
        }
      });
    }
  }

  addCategory() {
    this.crudCategoryService
      .addCategory(
        this.addCategoryForm.value.productId,
        this.addCategoryForm.value.categoryName,
        this.addCategoryForm.value.description
      )
      .subscribe(
        (data) => {
          if (data.didError) {
            swal({
              title: "",
              text: data.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          } else {
            swal({
              title: "",
              text: data.message,
              type: "success",
              confirmButtonClass: "btn btn-info",
            });
          }
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        },
        (error) => {
          let errorMessage =
            error.error?.title ??
            error.error ??
            "Something went wrong. Please contact admin.";

          // Check if it's a validation error response with the `errors` object
          if (error.error?.errors) {
            const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
            if (allErrors.length > 0) {
              errorMessage = allErrors[0]; // Use the first validation message
            }
          } else if (typeof error.error === "string") {
            errorMessage = error.error;
          } else if (error.error?.title) {
            errorMessage = error.error.title;
          }
          swal({
            title: "",
            text: errorMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
  }

  close() {
    this.dialogRef.close();
  }
}
